import React, { Component } from "react";
import whatsappIcon from "../images/whatsapp-icon.svg";

export default class WhatsappButton extends Component {
  constructor(props) {
    super(props);
    this.phone_number = props.attributes;
    this.qa = props.qa;
  }

  handleClick = () => {
    let message = "היי,%20ראיתי%20את%20הפרופיל%20שלך%20באפליקציית%20בייביסטר%20מיוחד.%20רציתי%20לשאול..."
    var url = 'whatsapp://send?text=';
    if (this.qa) {
      var url = 'whatsapp://send?text=היי,%20ארצה%20להצטרף%20לקבוצה%20בעיר%20';
    } else {
      url += message;
    }
    url += '&phone=';
    url += '+972';
    url += this.phone_number;
    console.log(url)
    window.location.assign(url);
  }

  render() {
    return (
        <div onClick={this.handleClick}>
            <button className="whatsapp_p_icon_button">
                <img src={whatsappIcon} width="50" height="50"/>
            </button>
        </div>
    );
  }
}
